import Car from '@serko/zui-icons/es/CarIcon';
import Flight from '@serko/zui-icons/es/FlightIcon';
import Hotel from '@serko/zui-icons/es/HotelIcon';
import React, { FunctionComponent } from 'react';
import pure from 'recompose/pure';
import { SegmentTypes } from '../models/itinerary';

interface SegmentIconProps {
  type: SegmentTypes;
  className?: string;
}

export const getIconByType = (type: SegmentTypes) => {
  switch (type) {
    case 'Hotel':
      return Hotel;
    case 'Air':
      return Flight;
    case 'Car':
      return Car;
  }
};

const SegmentIconBase: FunctionComponent<SegmentIconProps> = ({
  type,
  ...props
}) => {
  const Icon = getIconByType(type);

  return <Icon {...props} />;
};

/**
 * Segment icon
 *
 * Automatically switches the icon based on the segment type (e.g. `Air`, `Hotel` or `Car`)
 */
export const SegmentIcon = pure(SegmentIconBase);

SegmentIcon.displayName = 'SegmentIcon';
